<template>
  <div>
    <div class="drawer-subtitle_common">
      <span>{{status==1?"响应信息":"复查信息"}}</span>
    </div>
    <el-card class="margin_top_bottom20">
      <el-form label-width="100px">
        <el-form-item :label="getName().title" :required="true">
          <el-radio
            label="3"
            border
            size="small"
            class="no_circle_radio"
            v-model="rectification.status"
          >{{getName().radio1}}</el-radio>
          <el-radio
            label="4"
            border
            size="small"
            class="no_circle_radio"
            v-model="rectification.status"
          >{{getName().radio2}}</el-radio>
        </el-form-item>
        <el-form-item :label="getName().picTitle">
          <uploadPic @getpic="getpic"></uploadPic>
        </el-form-item>
        <el-form-item :label="getName().textTitle" >
          <el-input
            type="textarea"
            placeholder="请输入说明，请保持在200字以内。"
            class="common_textarea"
            maxlength="200"
            v-model="rectification.reportexplain"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import uploadPic from "@/views/CreditScore/common/uploadPic";

export default {
  props: {
    status: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      checkBtn: "",
      rectification:{
        reportexplain:'',
        status:'',
        reportpic:''
      }
    };
  },
  components: { uploadPic },
  methods: {
    getpic(imgList) {
      this.rectification.reportpic = String(imgList);
    },
    getName() {
      let data = {
        1: {
          title: "响应方式:",
          radio1: "我已整改",
          radio2: "我要申诉",
          picTitle: "申诉截图:",
          textTitle: "申诉理由:"
        },
        2: {
          title: "复查信息:",
          radio1: "整改合格",
          radio2: "整改不合格",
          picTitle: "复查截图:",
          textTitle: "备注说明:",
        },
      };
      return data[this.status];
    },
  }
};
</script>
